import { render, staticRenderFns } from "./FormCustomQuestionBlockSettings.vue?vue&type=template&id=4ecbe800"
import script from "./FormCustomQuestionBlockSettings.vue?vue&type=script&lang=js"
export * from "./FormCustomQuestionBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports